/**
 * Servicio que se encarga del manejo de las peticiones para las notas 
 * asignadas en el detalle de la pqr.
 * JMM-2018-07-25
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service'; 

@Injectable()
export class NotadetallepqrService {

  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  /**
   * Obtener el listado de registros
   * JMM-2018-07-25
   */
  getNotaDetallePqr(pqrid)
  {
    let url = this.PATH + '/api/public/listnotadetallepqr/'+pqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getNotaDetallePqr(pqrid)

  /**
   * Obtener un registro por id para editar
   * JMM-2018-07-25
   */
  getRegNotaDetallePqr(id:any)
  {
    let url = this.PATH + '/api/public/notadetallepqr/'+id;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRegNotaDetallePqr(id:any)

  /**
   * Enviar registro para guardarlo en bd
   * JMM-2018-07-25
   */
  setNotaDetallePqr(notadetallepqr:any)
  {
    let url = this.PATH + '/api/public/notadetallepqr';
    return this.http.post(url, notadetallepqr, {headers:this._key.head()}).map(resp => resp.json());
  }// .setNotaDetallePqr(notadetallepqr:any)

  /**
   * Obtener el listado de archivos de las notas
   * JMM-2018-10-25
   */
  getArchivoNotaDetallePqr(pqrid)
  {
    let url = this.PATH + '/api/public/listarchivonotadetallepqr/'+pqrid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getArchivoNotaDetallePqr(pqrid)

   /**
   * Edita la notas de las incidencias
   * CESAR ARIAS-2019-10-10
   */
  updateNotadetallepqr(data,id)
  {
    let url = this.PATH + '/api/public/notadetallepqr/'+id;
    return this.http.put(url,data ,{headers:this._key.head()}).map(resp => resp.json());
  }// .updateNotadetallepqr(id,data)

  /**
   * Eliminar notas pqr
   * CESAR ARIAS-2019-10-10
   */
  destroyNotasPqr(id:any)
  {
    let url = this.PATH + '/api/public/notadetallepqr/'+id;
    return this.http.delete(url, {headers:this._key.head()}).map( resp => resp.json());        
  }// .destroyMarcas(id:any)


}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/pqr/notadetallepqr.service.ts